import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const BreakawayPoleFlatAllTerrain = () => {
  console.log('🎯 BreakawayPoleFlatAllTerrain component loading');
  
  const product = findProductById("breakaway-pole-flat-all-terrain");
  
  if (!product) {
    console.error('Product not found:', "breakaway-pole-flat-all-terrain");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="breakaway-pole-flat-all-terrain"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default BreakawayPoleFlatAllTerrain; 